/**
 * @generated SignedSource<<a6f66957e5b443a2726199f6dba9f617>>
 * @relayHash 6be97cab74ae69b5d7bf3d3cd83d37de
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6be97cab74ae69b5d7bf3d3cd83d37de

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Aim = "ANALGESIA_ANTI_INFLAMMATORY_TREATMENT" | "DECONGESTION" | "FUNCTIONAL_BANDAGE_TAPE" | "IMPROVEMENT_OF_CARDIO_PULMO_FUNCTION" | "IMPROVEMENT_OF_JOINT_FUNCTION" | "IMPROVEMENT_OF_MOBILITY" | "IMPROVEMENT_OF_MUSCLE_FUNCTION" | "INSTRUCTION" | "PROPRIOCEPTION_COORDINATION";
export type ConditionStage = "ACUTE" | "CHRONIC" | "SUBACUTE";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type Occurrence = "FIRST_OCCURRENCE" | "RECURRENCE";
export type PrescriptionRepetition = "FIRST" | "FOURTH" | "SECOND" | "THIRD";
export type ReasonForPhysiotherapy = "ACCIDENT" | "IVMV" | "SICKNESS";
export type Side = "LEFT" | "RIGHT";
export type TreatmentUnitPerDay = "ONCE" | "TWICE";
export type Ch_updatePhysiotherapyPrescriptionInput = {
  aims: ReadonlyArray<Aim>;
  allergies: ReadonlyArray<string>;
  conditionStage: ConditionStage;
  conditions: ReadonlyArray<string>;
  diagnosisCode: string;
  duration?: string | null;
  healthcareProviderId?: string | null;
  id: string;
  internalNote?: string | null;
  isHomeTreatment: boolean;
  language: Language;
  leadingSymptom?: string | null;
  medicationIds: ReadonlyArray<string>;
  occurrence: Occurrence;
  prescriptionRepetition: PrescriptionRepetition;
  reason: ReasonForPhysiotherapy;
  sides?: ReadonlyArray<Side> | null;
  treatmentUnit: number;
  treatmentUnitPerDay: TreatmentUnitPerDay;
  trigger?: string | null;
};
export type useChUpdatePhysiotherapyMutation$variables = {
  input: Ch_updatePhysiotherapyPrescriptionInput;
};
export type useChUpdatePhysiotherapyMutation$data = {
  readonly ch_updatePhysiotherapyPrescription: {
    readonly ch_PhysiotherapyPrescription: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"chPhysiotherapyFragment">;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useChUpdatePhysiotherapyMutation = {
  response: useChUpdatePhysiotherapyMutation$data;
  variables: useChUpdatePhysiotherapyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChUpdatePhysiotherapyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updatePhysiotherapyPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_updatePhysiotherapyPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_PhysiotherapyPrescription",
            "kind": "LinkedField",
            "name": "ch_PhysiotherapyPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "chPhysiotherapyFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChUpdatePhysiotherapyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updatePhysiotherapyPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_updatePhysiotherapyPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_PhysiotherapyPrescription",
            "kind": "LinkedField",
            "name": "ch_PhysiotherapyPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "patientId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aims",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allergies",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "conditions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "medicationIds",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "conditionStage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "diagnosisCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "duration",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fileId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "healthcareProviderId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "internalNote",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "language",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "leadingSymptom",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "prescriptionRepetition",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "progressNoteId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sides",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "treatmentUnit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "trigger",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "treatmentUnitPerDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isHomeTreatment",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "occurrence",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sentAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sentBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "concludedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "concludedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DocumentFileMetadata",
                "kind": "LinkedField",
                "name": "fileMetadata",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "documentType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "extension",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lengthInKilobytes",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "6be97cab74ae69b5d7bf3d3cd83d37de",
    "metadata": {},
    "name": "useChUpdatePhysiotherapyMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "2e34d4ad9717815e448200bca87236f1";

export default node;
